var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.previewClasses },
    [
      _c(_vm.previewComponentName, {
        tag: "component",
        attrs: { result: _vm.result, itemData: _vm.result.data },
        on: { onResultClicked: _vm.onResultClicked }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }